import module from '@kendu/ui/module'
import './style.scss'

export class kdHoverableComponent {
  constructor ($element) {
    if ($element.attr('tabindex') === undefined) {
      $element.attr('tabindex', 0)
    }

    const onFocus = () => {
      $element.on('keypress', onKeyPress)
    }

    const onBlur = () => {
      $element.off('keypress', onKeyPress)
    }

    const onKeyPress = (event) => {
      if (event.which === 13) {
        event.target.click()
      }
    }

    $element.on('focus', onFocus)
    $element.on('blur', onBlur)
  }
}

module.directive('kdHoverable', () => ({
  controller: kdHoverableComponent,
  restrict: 'C',
}))



// WEBPACK FOOTER //
// ./src/kendu/ui/styles/kd-hoverable/directive.js